// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSelect_wrapper__tfuOQ","select":"LanguageSelect_select__JjydC","ant-select-selector":"LanguageSelect_ant-select-selector__8BCNy"};